import * as R from 'ramda';

export interface DurationDetail {
  hours: number;
  minutes: number;
  seconds: number;
}

export const getTimeDetail = (time: number): DurationDetail => {
  const totalSeconds = Math.floor(time / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const seconds = totalSeconds % 60;

  return { hours, minutes, seconds };
};

export const getDurationFormat = R.curry((format = '{HOURS}:{MINS}', duration: number) => {
  const timeDetail = getTimeDetail(duration);

  return format
    .replace('{HOURS}', timeDetail.hours.toString())
    .replace('{MINS}', timeDetail.minutes.toString())
    .replace('{SECS}', timeDetail.seconds.toString());
});



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/utils/duration.utils.ts